import { classnames, fHumanReadableNumber } from '@aibees/shared/utils';
import { memo } from 'react';
import { useNotificationsCount } from '../../hooks/use-notifications-count';
import * as Styled from './styles';
import type { NotificationTabProps as Props } from './types';

export const NotificationTab = memo(
  ({ className, value, label, disabled, ...other }: Props) => {
    const count = useNotificationsCount(value, disabled);

    return (
      <Styled.Tab
        className={classnames('NotificationTab', className)}
        value={value}
        key={value}
        disabled={disabled}
        LabelVariant="soft"
        label={label}
        LabelContent={fHumanReadableNumber(count ?? 0)}
        {...other}
      />
    );
  }
);

NotificationTab.displayName = 'NotificationTab';
